import _ from 'lodash';
import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { Field, reduxForm, propTypes, formValueSelector, getFormSyncErrors, change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveEmailSettings, savingEmailSettings, resetTemplateSettings } from "../../../redux/actions/seasonActions"
import { style, blue } from '../../../utils/constants'
import { isEmpty } from '../../../utils/functions'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'


const formName    = 'seasontemplate'
const templateTab = 7

class Template extends Component {
	static propTypes = {
		...propTypes
	}
	constructor(props,context) {
		super(props,context)
		this.handleSaveTemplate = this.handleSaveTemplate.bind(this) 
		this.handleValueChange  = this.handleValueChange.bind(this)
		this.renderEmailSettings = this.renderEmailSettings.bind(this)
	}
	componentDidUpdate(){
		const {  initialize,datasaved,settingsSaved,resetform } = this.props
		if (datasaved) {
				initialize({}, true)
				settingsSaved(true,templateTab)
		}
		if(resetform == true){
				resetTemplateSettings()
		}
	}
	handleSaveTemplate() {
		const { saveEmailSettings, template, settingsseason, dispatch } = this.props
		const season = template[settingsseason]
	
		dispatch(savingEmailSettings())
		saveEmailSettings(settingsseason,season.notificationSettings)
	}
	handleValueChange() {
		const { dispatch, settingsSaved } = this.props 
		dispatch(change(formName,'datasaved',false))
		settingsSaved(true,templateTab)
	}
	
	renderEmailSettings() {
		const { template, settingsseason }  = this.props
		const { notificationSettings } = template[settingsseason];
		const season      = `template[${settingsseason}]`
		if(isEmpty(notificationSettings) === false)	
		{
			const emailSetting = notificationSettings.map((setting, index) => {
			return (<FormGroup key={setting.id}>
				<label className={style.lblattrs5}>{setting.description}</label>
				<Field
						name={`${season}.notificationSettings[${index}.sendGridTemplateId]`}
						component='input'
						className="form-control no-spinners"
						style={{ maxWidth: '280px' }}
						onChange={this.handleValueChange}                         
				/>
			</FormGroup>)
			})
			return emailSetting;
		}
		return null;
	}
    render() {
			const { template, settingsseason,savingemailsettings,datasaved,seasonyears, syncErrors } = this.props
			const errors =  Object.values(syncErrors)
			let isSeasonSet = true
			if(template){
				isSeasonSet = template[settingsseason].isSeasonSet
			}
				
			return (
				<Row className="center-block center-text">
					<form className="form-horizontal" sm={12}  style={{ padding:'0',margin:'0' }} >
						<Col sm={12}>
							<FormGroup>
								<SeasonHeader seasonyears={seasonyears} />   
							</FormGroup>
							{ (errors.length > 0) && <ErrorList errors={errors}/> }
							
							<FormGroup>
							<Col sm={ 12 }>							
								{
									(isEmpty(template) === false) && this.renderEmailSettings()
								} 
								<button type="button"   className="btn btn-default"  style={{ color: blue, fontWeight: 800 }} onClick={this.handleSaveTemplate} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
									<i className={savingemailsettings === true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
								</button>
								{
									datasaved && (<InfoSaved section='Season template' />)
								}								
							</Col>
							</FormGroup>
						</Col>
					</form>
				</Row>
			)
	}
}
function validate(values) {
	const { settingsseason,template } = values
	const errors = {}
	let errorCounter = 0 
	
	if(template && settingsseason){
		const season = template[settingsseason]
		const { notificationSettings, isSeasonSet } = season		
		if(isSeasonSet === true){
			if(isEmpty(notificationSettings) === true) {
				errors[errorCounter++] = 'Notification settings are required'
			}
		}
		else {
			errors[errorCounter++]  = "Initiate the season by clicking 'Setup season'"
		}
	}
	if(values.template !== undefined) {		
		const seasonId = values['settingsseason'];
		const seasonTemplate =_.find(values.template, { seasonId:seasonId });		
		seasonTemplate.notificationSettings.map((item)=>isValidSendGridValue(item.sendGridTemplateId,errors))		
	}
	return errors
}
function isValidSendGridValue(sendGridId,errors) {			
	let errorCounter = errors.length;
	const regexGuid =  /^[a-f0-9-]+$/;		
	if (!regexGuid.test(sendGridId)) {
		errors[errorCounter++]="Invalid SendGrid Value"+ ( (sendGridId !== undefined) ? ": "+sendGridId : "" );
	}
	return errors;
} 
Template.propTypes = {
	dispatch:PropTypes.func,
	initialize:PropTypes.func,
	syncErrors:PropTypes.object,
	settingsseason:PropTypes.number,
	savingemailsettings:PropTypes.bool,
	datasaved:PropTypes.bool,
	seasonyears:PropTypes.string,
	template:PropTypes.object,
	saveEmailSettings:PropTypes.func,
	savingEmailSettings:PropTypes.func,
	settingsSaved:PropTypes.func,
	resetTemplateSettings:PropTypes.func,
	resetform:PropTypes.bool,
	resetDone:PropTypes.func
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const settingsseason = selector(state,'settingsseason')
	const template       = selector(state,'template')
	const savingemailsettings     = selector(state,'savingemailsettings')
	const datasaved      = selector(state,'datasaved')
	const syncErrors = getFormSyncErrors(formName)(state)
	return {     
		settingsseason,
		template,
		savingemailsettings,
		datasaved,
		syncErrors  
	}
}
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveEmailSettings,
		savingEmailSettings,
	},dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
	enableReinitialize: true,
	keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Template))




// WEBPACK FOOTER //
// ./src/containers/season/components/Template.js